// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-card {
	/* align-self: center; */
	/* position: fixed; */
	background: rgba(255, 255, 255, 0.5);
	/* top: 95px; */
	/* right: 30px; */
	/* border: 3px solid white; */
	box-shadow: 0 0 50px 15px black;
	border-radius: 5px;
	width: 250px;
}

.profile-card-img {
    width: 225px;
    height: 225px;
	object-fit: cover;	
	border-radius: 50%;
	margin-top: 10px;
}

.profile-card h1 {
	width: 100%;
	padding: 0;
	margin: 10px 0px;
	background: black;
	color: white;
	height: fit-content;
	line-height: unset;
}

.profile-card a {
	text-decoration: none;
}

@media (max-width: 696px) {
	.landing-page-a {
		/* top: 70%; */
	}
}`, "",{"version":3,"sources":["webpack://./src/components/elements/profile-card/profile-card.css"],"names":[],"mappings":"AAAA;CACC,wBAAwB;CACxB,qBAAqB;CACrB,oCAAoC;CACpC,eAAe;CACf,iBAAiB;CACjB,6BAA6B;CAC7B,+BAA+B;CAC/B,kBAAkB;CAClB,YAAY;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,UAAU;CACV,gBAAgB;CAChB,iBAAiB;CACjB,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC;EACC,cAAc;CACf;AACD","sourcesContent":[".profile-card {\n\t/* align-self: center; */\n\t/* position: fixed; */\n\tbackground: rgba(255, 255, 255, 0.5);\n\t/* top: 95px; */\n\t/* right: 30px; */\n\t/* border: 3px solid white; */\n\tbox-shadow: 0 0 50px 15px black;\n\tborder-radius: 5px;\n\twidth: 250px;\n}\n\n.profile-card-img {\n    width: 225px;\n    height: 225px;\n\tobject-fit: cover;\t\n\tborder-radius: 50%;\n\tmargin-top: 10px;\n}\n\n.profile-card h1 {\n\twidth: 100%;\n\tpadding: 0;\n\tmargin: 10px 0px;\n\tbackground: black;\n\tcolor: white;\n\theight: fit-content;\n\tline-height: unset;\n}\n\n.profile-card a {\n\ttext-decoration: none;\n}\n\n@media (max-width: 696px) {\n\t.landing-page-a {\n\t\t/* top: 70%; */\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
